import { Button, Stack, Typography } from '@mui/material';
import { z } from 'zod';

import { useAppForm } from '@/hooks/useAppForm';
import { I18N_DE } from '@/i18n/de';
import type { CreateOrganizationUserDto } from '@/modules/api/backend';
import { OrganizationUserRole } from '@/modules/api/backend';
import { zOrganizationUserRole } from '@/modules/api/backend/zod.gen';

interface InviteUserFormProps {
  onSubmit: (values: CreateOrganizationUserDto) => Promise<void>;

  onCancel: () => void;
}

export function InviteOrganizationUserForm({ onSubmit, onCancel }: InviteUserFormProps) {
  const form = useAppForm({
    defaultValues: { email: '', role: OrganizationUserRole.EDITOR as keyof typeof OrganizationUserRole },
    onSubmit: async ({ value }) => {
      await onSubmit({
        email: value.email,
        role: value.role,
      });
    },
  });

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        event.stopPropagation();
        form.handleSubmit();
      }}
    >
      <Stack spacing={3}>
        <Typography variant="h2">User*in hinzufügen</Typography>

        <form.AppField
          name="email"
          validators={{
            onChange: z.email(),
          }}
        >
          {(field) => <field.TextField label="E-Mail" />}
        </form.AppField>

        <form.AppField
          name="role"
          validators={{
            onChange: zOrganizationUserRole,
          }}
        >
          {(field) => (
            <field.SelectField
              label="Rolle"
              options={Object.entries(I18N_DE.OrganizationUserRole).map(([value, label]) => ({
                value,
                label,
              }))}
            />
          )}
        </form.AppField>

        <Stack alignItems="center" direction="row" justifyContent="flex-end" spacing={2}>
          <Button color="primary" onClick={onCancel} variant="outlined">
            Abbrechen
          </Button>
          <Button type="submit" variant="contained">
            Einladen
          </Button>
        </Stack>
      </Stack>
    </form>
  );
}
